import React, { Component } from 'react';
import { connect } from 'react-redux';
import ClientNotesView from './ClientNotes.view';

export class ClientNotesContainer extends Component {

  constructor(props){
    super(props);
    this.onFormChange = this.onFormChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.toggleAddNote = this.toggleAddNote.bind(this);
  }

  // componentWillMount(){
  //   debugger;
  // }

  onFormChange(formState){
    const { dispatch } = this.props;
    dispatch({
      type: 'CLIENT_NOTES_FORM_CHANGE',
      payload: {
        formState,
      }
    });
  }

  submitForm(formState) {
    const { dispatch, username } = this.props;
    const { note } = formState.data;
    dispatch({
      // $global: true,
      type: 'CLIENT_ADD_NOTE',
      payload: {
        username,
        note
      }
    });
  }

  toggleAddNote(active) {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_ADD_NOTE',
      payload: {
        active,
      }
    });
  }

  render() {
    return (<ClientNotesView
      {...this.props}
      {...this.state}
      onFormChange={this.onFormChange}
      submitForm={this.submitForm}
      toggleAddNote={this.toggleAddNote}
    />);
  }

}

function mapStateToProps(state, ownProps) {
  const { formState, addNoteActive } = state.clientNotes;
  const { client } = ownProps;
  return {
    notes: client.notes,
    username: client.username,
    addNoteActive,
    formState,
  };
}

export default connect(mapStateToProps)(ClientNotesContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ClientModal/ClientNotes/ClientNotes.container.js